module.exports = __webpack_public_path__ + "img/pokemon.0dbd158b.png";